import React, { Component } from "react";
import "./stylesheets/allowance.css";
import HeaderBack from "../../../components/backoffice/headerback/HeaderBack";
import {
  getBackSiteid,
  getBackJobsAllowance,
  getUpdateAllowance,
  getAddTechnician,
  getBackAllowanceTechnicians,
  getSubmitIncentive,
  getSubmitBtnAllowances,
} from "../../../modules/serverCall";
import "react-datepicker/dist/react-datepicker.css";
import BootstrapTable from "react-bootstrap-table-next";
import Moment from "moment";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import DatePicker from "react-datepicker";
import { AiOutlineCheckCircle } from "react-icons/ai";
import {
  Button,
  Dropdown,
  Offcanvas,
  FloatingLabel,
  Form,
} from "react-bootstrap";
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";
import overlayFactory from "react-bootstrap-table2-overlay";

export default class Allowance extends Component {
  constructor(props) {
    super(props);
    var startDateData = Moment(new Date());
    var futureMonth = Moment(startDateData).add(-1, "M");
    var currnetmonthMain = new Date(futureMonth);
    this.state = {
      showData: false,
      scroll: false,
      backdrop: false,
      loading: false,
      placement: "end",
      allowancedetails: [],
      listTechnicians: [],
      expanded: [0, 1],
      currnetmonthdata: currnetmonthMain,
      customer: "Add Technicians",
      statusId: "TLA",
      selectedStatus: "TL Allowance",
      siteId: 0,
      selectedSite: "Site Id",
      listSiteId: "",
      submitbtn: false,
      loading: false,
      showbtn: false,
      loadingData: "No data found",
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    const accesstokendata = localStorage.getItem("access_token");
    const readData = JSON.parse(accesstokendata);
    const userId = readData.userdata.user_id;
    var sendData = {
      userid: userId,
    };
    const fetchsiteid = async () => {
      const responsesites = await getBackSiteid(sendData);
      const datarespsites = await responsesites;
      var siteIdArr = [];
      for (var i = 0; i < datarespsites.length; i++) {
        var siteId = {};
        siteId.key = datarespsites[i].SiteID;
        siteId.value = datarespsites[i].SiteName;
        siteIdArr.push(siteId);
      }
      this.setState({
        listSiteId: siteIdArr,
        selectedSite: siteIdArr[0].value,
        siteId: siteIdArr[0].key,
      });
    };
    fetchsiteid();
  }

  handleInputFetch = (event) => {
    var AllowanceArr = [];
    var submitbtn = true;
    var loadingData = "No data found";
    this.setState({
      loading: true,
      loadingData: "Loading",
    });
    var dateData = this.state.currnetmonthdata;
    var monthData = dateData.getMonth();
    var year = dateData.getFullYear();
    const siteId = this.state.siteId;
    const statusId = this.state.statusId;
    var sendData = {
      month: monthData + 1,
      year: year,
      site_id: siteId,
      status_id: statusId,
    };
    const fetchAllowancedetails = async () => {
      const responseAllowance = await getBackJobsAllowance(sendData);
      const datarespAllowance = await responseAllowance;
      const responseSubmitAllowance = await getSubmitBtnAllowances(sendData);
      const datarespSubmitAllowance = await responseSubmitAllowance;
      if (datarespAllowance.length > 0) {
        // const filtered = datarespAllowance.filter(obj => {
        //   return obj.ShowSubmit === true;
        //   });
        //   if(filtered.length >0){
        //     submitbtn = filtered[0].ShowSubmit;
        //   }else{
        //     submitbtn = false;
        //   }
        for (let index = 0; index < datarespAllowance.length; index++) {
          var AllowanceObj = {};
          var valueData = 0;
          for (let indexi = 1; indexi < 32; indexi++) {
            var indexvaldata = "D" + indexi;
            valueData += parseFloat(datarespAllowance[index][indexvaldata]);
          }
          AllowanceObj = datarespAllowance[index];
          AllowanceObj.Total = valueData;
          AllowanceObj.index = index;
          AllowanceObj.DisplayData =
            datarespAllowance[index].LoginID +
            " - " +
            datarespAllowance[index].DisplayName;
          AllowanceArr.push(AllowanceObj);
        }
      } else {
        loadingData = "No data found";
      }

      submitbtn = datarespSubmitAllowance.ShowSubmit;

      this.setState({
        allowancedetails: AllowanceArr,
        loading: false,
        showbtn: submitbtn,
        submitbtn: submitbtn,
        loadingData: loadingData,
      });
    };
    fetchAllowancedetails();
  };

  handleDropdown = (key, event) => {
    this.setState({
      selectedStatus: event.target.innerHTML,
      statusId: key,
      allowancedetails: [],
      submitbtn: false,
      showbtn: false,
    });
  };

  handleDropdownSite = (key, event) => {
    this.setState({
      selectedSite: event.target.innerHTML,
      siteId: key,
      allowancedetails: [],
      submitbtn: false,
      showbtn: false,
    });
  };

  handleInputChange = (event) => {
    this.setState({
      currnetmonthdata: event,
      allowancedetails: [],
      submitbtn: false,
      showbtn: false,
    });
  };

  // priceFormatter = event => {
  // if(event === 0){
  //   return '';
  // }else{
  //   return parseFloat(event);
  // }
  // }

  handleactionFormater = (event) => {
    this.setState({
      loading: true,
    });
    const accesstokendata = localStorage.getItem("access_token");
    const readData = JSON.parse(accesstokendata);
    const userId = readData.userdata.user_id;
    const JobAllowanceID = event.JobAllowanceID;
    var submitData = {
      JobAllowanceID: event.JobAllowanceID,
      AllowanceType: event.AllowanceType,
      SiteID: event.SiteID,
      TechnicianID: event.TechnicianID,
      LoginID: event.LoginID,
      DisplayName: event.DisplayName,
      MonthOfAllowance: event.MonthOfAllowance,
      D1: parseFloat(event.D1),
      D2: parseFloat(event.D2),
      D3: parseFloat(event.D3),
      D4: parseFloat(event.D4),
      D5: parseFloat(event.D5),
      D6: parseFloat(event.D6),
      D7: parseFloat(event.D7),
      D8: parseFloat(event.D8),
      D9: parseFloat(event.D9),
      D10: parseFloat(event.D10),
      D11: parseFloat(event.D11),
      D12: parseFloat(event.D12),
      D13: parseFloat(event.D13),
      D14: parseFloat(event.D14),
      D15: parseFloat(event.D15),
      D16: parseFloat(event.D16),
      D17: parseFloat(event.D17),
      D18: parseFloat(event.D18),
      D19: parseFloat(event.D19),
      D20: parseFloat(event.D20),
      D21: parseFloat(event.D21),
      D22: parseFloat(event.D22),
      D23: parseFloat(event.D23),
      D24: parseFloat(event.D24),
      D25: parseFloat(event.D25),
      D26: parseFloat(event.D26),
      D27: parseFloat(event.D27),
      D28: parseFloat(event.D28),
      D29: parseFloat(event.D29),
      D30: parseFloat(event.D30),
      D31: parseFloat(event.D31),
      Remarks: event.Remarks,
      ModifiedBy: userId,
    };
    const saveAllowance = async () => {
      const responsesites = await getUpdateAllowance(
        submitData,
        JobAllowanceID
      );
      const collection = document.getElementsByClassName(
        "demo-row-odd" + event.TechnicianID + ""
      );
      collection[0].style.color = "black";
      const collectiondata = document.getElementsByClassName(
        "demo-row-odd-data" + event.TechnicianID + ""
      );
      collectiondata[0].style.color = "black";
      // if(responsesites === 200){
      this.handleInputFetch();
      this.state({
        loading: false,
      });
      // }
    };
    saveAllowance();
  };

  handleSubmit = (event) => {
    event.preventDefault();
    const accesstokendata = localStorage.getItem("access_token");
    const readData = JSON.parse(accesstokendata);
    const userId = readData.userdata.user_id;
    const currentMonthdata = this.state.currnetmonthdata;
    var submitData = {
      SiteID: this.state.siteId,
      TechnicianID: this.state.TechnicianData,
      AllowanceType: this.state.statusId,
      MonthOfAllowance: Moment(currentMonthdata)
        .startOf("month")
        .format("YYYY-MM-DD"),
      ModifiedBy: userId,
    };
    const addTechnician = async () => {
      const responsesites = await getAddTechnician(submitData);
      this.handleInputFetch();
      this.setState({ showData: false });
    };
    addTechnician();
  };

  handleSubmitAll = (event) => {
    const accesstokendata = localStorage.getItem("access_token");
    const readData = JSON.parse(accesstokendata);
    const userId = readData.userdata.user_id;
    var dateData = this.state.currnetmonthdata;
    var monthData = dateData.getMonth();
    var year = dateData.getFullYear();
    var Status = 60;

    const permissionsdata = localStorage.getItem("permissions");
    const permissionsreadData = JSON.parse(permissionsdata);
    const filteredData = permissionsreadData.filter((obj) => {
      return (
        obj.PermissionCode === "VALIDATE_JOB" ||
        obj.PermissionCode === "AUTHORIZE_JOB"
      );
    });
    if (filteredData.length > 0) {
      if (filteredData[0].PermissionCode === "VALIDATE_JOB") {
        Status = 60;
      } else if (filteredData[0].PermissionCode === "AUTHORIZE_JOB") {
        Status = 90;
      }
    }

    var submitData = {
      SiteId: this.state.siteId,
      Month: monthData + 1,
      Year: year,
      Status: Status,
      ModifiedBy: userId,
      TypeOfEntry: this.state.statusId,
    };
    const submitIncentive = async () => {
      const responsesites = await getSubmitIncentive(submitData);
      this.handleInputFetch();
    };
    var msg =
      "Once submitted, you will not be able to make any modifications. Are you sure you want to submit for the month?.";
    Swal.fire({
      title: "Are you sure?",
      text: msg,
      icon: "warning",
      showCancelButton: true,
      allowOutsideClick: false,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        submitIncentive();
      }
    });
  };

  handleClose = (event) => {
    this.setState({ showData: false });
  };

  handleDataChangeOther = (event) => {
    event.preventDefault();
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  handleShow = (event, row) => {
    var dateData = this.state.currnetmonthdata;
    var monthData = dateData.getMonth();
    var year = dateData.getFullYear();
    const siteId = this.state.siteId;
    const statusId = this.state.statusId;
    var sendData = {
      month: monthData + 1,
      year: year,
      site_id: siteId,
      status_id: statusId,
    };
    const fetchTechnicians = async () => {
      const responseTechnicians = await getBackAllowanceTechnicians(sendData);
      const datarespTechnicians = await responseTechnicians;
      var techniciansListArr = [];
      if (datarespTechnicians.length > 0) {
        for (var i = 0; i < datarespTechnicians.length; i++) {
          var techniciansList = {};
          techniciansList.TechnicianID = datarespTechnicians[i].TechnicianID;
          techniciansList.TechnicianName =
            datarespTechnicians[i].TechnicianName;
          techniciansList.EmployeeID = datarespTechnicians[i].EmployeeID;
          techniciansListArr.push(techniciansList);
        }
        this.setState({
          listTechnicians: techniciansListArr,
          TechnicianData: techniciansListArr[0].TechnicianID,
        });
      }
    };
    fetchTechnicians();
    this.setState({ showData: true });
  };

  getInitialBid = (oldValue, newValue, row, column) => {
    var indexData = row.index;
    var valueData = 0;
    for (let index = 1; index < 32; index++) {
      var indexvaldata = "D" + index;
      if (row[indexvaldata] !== "" && row[indexvaldata] !== undefined) {
        valueData += parseFloat(row[indexvaldata]);
      }
    }
    this.setState(
      (state, props) => {
        state.allowancedetails[indexData].Total = valueData;
        return {
          allowancedetails: state.allowancedetails,
        };
      },
      () => {
        const collection = document.getElementsByClassName(
          "demo-row-odd" + row.TechnicianID + ""
        );
        collection[0].style.color = "red";
        const collectiondata = document.getElementsByClassName(
          "demo-row-odd-data" + row.TechnicianID + ""
        );
        collectiondata[0].style.color = "red";
      }
    );

    // return this.state.data.find(r => r.rank === row.rank).initialBid;
  };

  render() {
    const addUserLogo = require("../../../assets/images/add_user.png");
    const loadingImg = require("../../../assets/images/Hourglass.gif");

    var currnetMonthData = this.state.currnetmonthdata;
    var currnetMonth = "";
    var columns = "";
    if (currnetMonthData === "") {
      currnetMonth = new Date();
    } else {
      currnetMonth = currnetMonthData;
    }
    var listSiteId = this.state.listSiteId;
    var listStatus = [
      { key: "TLA", value: "TL Allowance" },
      { key: "SPA", value: "Supervisor Allowance" },
      { key: "UGA", value: "UG Allowance" },
      { key: "SWA", value: "SW Allowance" },
    ];

    columns = [
      {
        dataField: "DisplayData",
        text: "Name",
        classes: (cell, row, rowIndex, colIndex) => {
          return "mainsticy demo-row-odd" + row.TechnicianID;
        },
        editable: false,
      },
      {
        dataField: "D1",
        headerClasses: "master-headerCode",
        text: "1",
        classes: (cell, row, rowIndex, colIndex) => {
          if (row.A1 === "N") {
            return "amountMul grayData";
          } else if (row.D1 !== 0 && row.D1 !== "0" && row.D1 !== "") {
            return "amountMul greenData";
          } else {
            return "amountMul";
          }
        },
        editable: (cell, row, rowIndex, colIndex) => {
          if (row.A1 === "Y") {
            return true;
          } else {
            return false;
          }
        },
        validator: (newValue, row, column) => {
          if (isNaN(newValue)) {
            return {
              valid: false,
              message: "Amount should be numeric",
            };
          }
          return true;
        },
      },
      {
        dataField: "D2",
        text: "2",
        headerClasses: "master-headerCode",
        validator: (newValue, row, column) => {
          if (isNaN(newValue)) {
            return {
              valid: false,
              message: "Amount should be numeric",
            };
          }
          return true;
        },
        classes: (cell, row, rowIndex, colIndex) => {
          if (row.A2 === "N") {
            return "amountMul grayData";
          } else if (row.D2 !== 0 && row.D2 !== "0" && row.D2 !== "") {
            return "amountMul greenData";
          } else {
            return "amountMul";
          }
        },
        editable: (cell, row, rowIndex, colIndex) => {
          if (row.A2 === "Y") {
            return true;
          } else {
            return false;
          }
        },
      },
      {
        dataField: "D3",
        text: "3",
        headerClasses: "master-headerCode",
        validator: (newValue, row, column) => {
          if (isNaN(newValue)) {
            return {
              valid: false,
              message: "Amount should be numeric",
            };
          }
          return true;
        },
        classes: (cell, row, rowIndex, colIndex) => {
          if (row.A3 === "N") {
            return "amountMul grayData";
          } else if (row.D3 !== 0 && row.D3 !== "0" && row.D3 !== "") {
            return "amountMul greenData";
          } else {
            return "amountMul";
          }
        },
        editable: (cell, row, rowIndex, colIndex) => {
          if (row.A3 === "Y") {
            return true;
          } else {
            return false;
          }
        },
      },
      {
        dataField: "D4",
        text: "4",
        headerClasses: "master-headerCode",
        validator: (newValue, row, column) => {
          if (isNaN(newValue)) {
            return {
              valid: false,
              message: "Amount should be numeric",
            };
          }
          return true;
        },
        classes: (cell, row, rowIndex, colIndex) => {
          if (row.A4 === "N") {
            return "amountMul grayData";
          } else if (row.D4 !== 0 && row.D4 !== "0" && row.D4 !== "") {
            return "amountMul greenData";
          } else {
            return "amountMul";
          }
        },
        editable: (cell, row, rowIndex, colIndex) => {
          if (row.A4 === "Y") {
            return true;
          } else {
            return false;
          }
        },
      },
      {
        dataField: "D5",
        text: "5",
        headerClasses: "master-headerCode",
        validator: (newValue, row, column) => {
          if (isNaN(newValue)) {
            return {
              valid: false,
              message: "Amount should be numeric",
            };
          }
          return true;
        },
        classes: (cell, row, rowIndex, colIndex) => {
          if (row.A5 === "N") {
            return "amountMul grayData";
          } else if (row.D5 !== 0 && row.D5 !== "0" && row.D5 !== "") {
            return "amountMul greenData";
          } else {
            return "amountMul";
          }
        },
        editable: (cell, row, rowIndex, colIndex) => {
          if (row.A5 === "Y") {
            return true;
          } else {
            return false;
          }
        },
      },
      {
        dataField: "D6",
        text: "6",
        headerClasses: "master-headerCode",
        validator: (newValue, row, column) => {
          if (isNaN(newValue)) {
            return {
              valid: false,
              message: "Amount should be numeric",
            };
          }
          return true;
        },
        classes: (cell, row, rowIndex, colIndex) => {
          if (row.A6 === "N") {
            return "amountMul grayData";
          } else if (row.D6 !== 0 && row.D6 !== "0" && row.D6 !== "") {
            return "amountMul greenData";
          } else {
            return "amountMul";
          }
        },
        editable: (cell, row, rowIndex, colIndex) => {
          if (row.A6 === "Y") {
            return true;
          } else {
            return false;
          }
        },
      },
      {
        dataField: "D7",
        text: "7",
        headerClasses: "master-headerCode",
        validator: (newValue, row, column) => {
          if (isNaN(newValue)) {
            return {
              valid: false,
              message: "Amount should be numeric",
            };
          }
          return true;
        },
        classes: (cell, row, rowIndex, colIndex) => {
          if (row.A7 === "N") {
            return "amountMul grayData";
          } else if (row.D7 !== 0 && row.D7 !== "0" && row.D7 !== "") {
            return "amountMul greenData";
          } else {
            return "amountMul";
          }
        },
        editable: (cell, row, rowIndex, colIndex) => {
          if (row.A7 === "Y") {
            return true;
          } else {
            return false;
          }
        },
      },
      {
        dataField: "D8",
        text: "8",
        headerClasses: "master-headerCode",
        validator: (newValue, row, column) => {
          if (isNaN(newValue)) {
            return {
              valid: false,
              message: "Amount should be numeric",
            };
          }
          return true;
        },
        classes: (cell, row, rowIndex, colIndex) => {
          if (row.A8 === "N") {
            return "amountMul grayData";
          } else if (row.D8 !== 0 && row.D8 !== "0" && row.D8 !== "") {
            return "amountMul greenData";
          } else {
            return "amountMul";
          }
        },
        editable: (cell, row, rowIndex, colIndex) => {
          if (row.A8 === "Y") {
            return true;
          } else {
            return false;
          }
        },
      },
      {
        dataField: "D9",
        text: "9",
        headerClasses: "master-headerCode",
        validator: (newValue, row, column) => {
          if (isNaN(newValue)) {
            return {
              valid: false,
              message: "Amount should be numeric",
            };
          }
          return true;
        },
        classes: (cell, row, rowIndex, colIndex) => {
          if (row.A9 === "N") {
            return "amountMul grayData";
          } else if (row.D9 !== 0 && row.D9 !== "0" && row.D9 !== "") {
            return "amountMul greenData";
          } else {
            return "amountMul";
          }
        },
        editable: (cell, row, rowIndex, colIndex) => {
          if (row.A9 === "Y") {
            return true;
          } else {
            return false;
          }
        },
      },
      {
        dataField: "D10",
        text: "10",
        headerClasses: "master-headerCode",
        validator: (newValue, row, column) => {
          if (isNaN(newValue)) {
            return {
              valid: false,
              message: "Amount should be numeric",
            };
          }
          return true;
        },
        classes: (cell, row, rowIndex, colIndex) => {
          if (row.A10 === "N") {
            return "amountMul grayData";
          } else if (row.D10 !== 0 && row.D10 !== "0" && row.D10 !== "") {
            return "amountMul greenData";
          } else {
            return "amountMul";
          }
        },
        editable: (cell, row, rowIndex, colIndex) => {
          if (row.A10 === "Y") {
            return true;
          } else {
            return false;
          }
        },
      },
      {
        dataField: "D11",
        text: "11",
        editorClasses: "editing-all",
        validator: (newValue, row, column) => {
          if (isNaN(newValue)) {
            return {
              valid: false,
              message: "Amount should be numeric",
            };
          }
          return true;
        },
        classes: (cell, row, rowIndex, colIndex) => {
          if (row.A11 === "N") {
            return "amountMul grayData";
          } else if (row.D11 !== 0 && row.D11 !== "0" && row.D11 !== "") {
            return "amountMul greenData";
          } else {
            return "amountMul";
          }
        },
        editable: (cell, row, rowIndex, colIndex) => {
          if (row.A11 === "Y") {
            return true;
          } else {
            return false;
          }
        },
      },
      {
        dataField: "D12",
        text: "12",
        editorClasses: "editing-all",
        validator: (newValue, row, column) => {
          if (isNaN(newValue)) {
            return {
              valid: false,
              message: "Amount should be numeric",
            };
          }
          return true;
        },
        classes: (cell, row, rowIndex, colIndex) => {
          if (row.A12 === "N") {
            return "amountMul grayData";
          } else if (row.D12 !== 0 && row.D12 !== "0" && row.D12 !== "") {
            return "amountMul greenData";
          } else {
            return "amountMul";
          }
        },
        editable: (cell, row, rowIndex, colIndex) => {
          if (row.A12 === "Y") {
            return true;
          } else {
            return false;
          }
        },
      },
      {
        dataField: "D13",
        text: "13",
        editorClasses: "editing-all",
        validator: (newValue, row, column) => {
          if (isNaN(newValue)) {
            return {
              valid: false,
              message: "Amount should be numeric",
            };
          }
          return true;
        },
        classes: (cell, row, rowIndex, colIndex) => {
          if (row.A13 === "N") {
            return "amountMul grayData";
          } else if (row.D13 !== 0 && row.D13 !== "0" && row.D13 !== "") {
            return "amountMul greenData";
          } else {
            return "amountMul";
          }
        },
        editable: (cell, row, rowIndex, colIndex) => {
          if (row.A13 === "Y") {
            return true;
          } else {
            return false;
          }
        },
      },
      {
        dataField: "D14",
        text: "14",
        editorClasses: "editing-all",
        validator: (newValue, row, column) => {
          if (isNaN(newValue)) {
            return {
              valid: false,
              message: "Amount should be numeric",
            };
          }
          return true;
        },
        classes: (cell, row, rowIndex, colIndex) => {
          if (row.A14 === "N") {
            return "amountMul grayData";
          } else if (row.D14 !== 0 && row.D14 !== "0" && row.D14 !== "") {
            return "amountMul greenData";
          } else {
            return "amountMul";
          }
        },
        editable: (cell, row, rowIndex, colIndex) => {
          if (row.A14 === "Y") {
            return true;
          } else {
            return false;
          }
        },
      },
      {
        dataField: "D15",
        text: "15",
        editorClasses: "editing-all",
        validator: (newValue, row, column) => {
          if (isNaN(newValue)) {
            return {
              valid: false,
              message: "Amount should be numeric",
            };
          }
          return true;
        },
        classes: (cell, row, rowIndex, colIndex) => {
          if (row.A15 === "N") {
            return "amountMul grayData";
          } else if (row.D15 !== 0 && row.D15 !== "0" && row.D15 !== "") {
            return "amountMul greenData";
          } else {
            return "amountMul";
          }
        },
        editable: (cell, row, rowIndex, colIndex) => {
          if (row.A15 === "Y") {
            return true;
          } else {
            return false;
          }
        },
      },
      {
        dataField: "D16",
        text: "16",
        editorClasses: "editing-all",
        validator: (newValue, row, column) => {
          if (isNaN(newValue)) {
            return {
              valid: false,
              message: "Amount should be numeric",
            };
          }
          return true;
        },
        classes: (cell, row, rowIndex, colIndex) => {
          if (row.A16 === "N") {
            return "amountMul grayData";
          } else if (row.D16 !== 0 && row.D16 !== "0" && row.D15 !== "") {
            return "amountMul greenData";
          } else {
            return "amountMul";
          }
        },
        editable: (cell, row, rowIndex, colIndex) => {
          if (row.A16 === "Y") {
            return true;
          } else {
            return false;
          }
        },
      },
      {
        dataField: "D17",
        text: "17",
        editorClasses: "editing-all",
        validator: (newValue, row, column) => {
          if (isNaN(newValue)) {
            return {
              valid: false,
              message: "Amount should be numeric",
            };
          }
          return true;
        },
        classes: (cell, row, rowIndex, colIndex) => {
          if (row.A17 === "N") {
            return "amountMul grayData";
          } else if (row.D17 !== 0 && row.D17 !== "0" && row.D17 !== "") {
            return "amountMul greenData";
          } else {
            return "amountMul";
          }
        },
        editable: (cell, row, rowIndex, colIndex) => {
          if (row.A17 === "Y") {
            return true;
          } else {
            return false;
          }
        },
      },
      {
        dataField: "D18",
        text: "18",
        editorClasses: "editing-all",
        validator: (newValue, row, column) => {
          if (isNaN(newValue)) {
            return {
              valid: false,
              message: "Amount should be numeric",
            };
          }
          return true;
        },
        classes: (cell, row, rowIndex, colIndex) => {
          if (row.A18 === "N") {
            return "amountMul grayData";
          } else if (row.D18 !== 0 && row.D18 !== "0" && row.D18 !== "") {
            return "amountMul greenData";
          } else {
            return "amountMul";
          }
        },
        editable: (cell, row, rowIndex, colIndex) => {
          if (row.A18 === "Y") {
            return true;
          } else {
            return false;
          }
        },
      },
      {
        dataField: "D19",
        text: "19",
        editorClasses: "editing-all",
        validator: (newValue, row, column) => {
          if (isNaN(newValue)) {
            return {
              valid: false,
              message: "Amount should be numeric",
            };
          }
          return true;
        },
        classes: (cell, row, rowIndex, colIndex) => {
          if (row.A19 === "N") {
            return "amountMul grayData";
          } else if (row.D19 !== 0 && row.D19 !== "0" && row.D19 !== "") {
            return "amountMul greenData";
          } else {
            return "amountMul";
          }
        },
        editable: (cell, row, rowIndex, colIndex) => {
          if (row.A19 === "Y") {
            return true;
          } else {
            return false;
          }
        },
      },
      {
        dataField: "D20",
        text: "20",
        editorClasses: "editing-all",
        validator: (newValue, row, column) => {
          if (isNaN(newValue)) {
            return {
              valid: false,
              message: "Amount should be numeric",
            };
          }
          return true;
        },
        classes: (cell, row, rowIndex, colIndex) => {
          if (row.A20 === "N") {
            return "amountMul grayData";
          } else if (row.D20 !== 0 && row.D20 !== "0" && row.D20 !== "") {
            return "amountMul greenData";
          } else {
            return "amountMul";
          }
        },
        editable: (cell, row, rowIndex, colIndex) => {
          if (row.A20 === "Y") {
            return true;
          } else {
            return false;
          }
        },
      },
      {
        dataField: "D21",
        text: "21",
        editorClasses: "editing-all",
        validator: (newValue, row, column) => {
          if (isNaN(newValue)) {
            return {
              valid: false,
              message: "Amount should be numeric",
            };
          }
          return true;
        },
        classes: (cell, row, rowIndex, colIndex) => {
          if (row.A21 === "N") {
            return "amountMul grayData";
          } else if (row.D21 !== 0 && row.D21 !== "0" && row.D21 !== "") {
            return "amountMul greenData";
          } else {
            return "amountMul";
          }
        },
        editable: (cell, row, rowIndex, colIndex) => {
          if (row.A21 === "Y") {
            return true;
          } else {
            return false;
          }
        },
      },
      {
        dataField: "D22",
        text: "22",
        editorClasses: "editing-all",
        validator: (newValue, row, column) => {
          if (isNaN(newValue)) {
            return {
              valid: false,
              message: "Amount should be numeric",
            };
          }
          return true;
        },
        classes: (cell, row, rowIndex, colIndex) => {
          if (row.A22 === "N") {
            return "amountMul grayData";
          } else if (row.D22 !== 0 && row.D22 !== "0" && row.D22 !== "") {
            return "amountMul greenData";
          } else {
            return "amountMul";
          }
        },
        editable: (cell, row, rowIndex, colIndex) => {
          if (row.A22 === "Y") {
            return true;
          } else {
            return false;
          }
        },
      },
      {
        dataField: "D23",
        text: "23",
        editorClasses: "editing-all",
        validator: (newValue, row, column) => {
          if (isNaN(newValue)) {
            return {
              valid: false,
              message: "Amount should be numeric",
            };
          }
          return true;
        },
        classes: (cell, row, rowIndex, colIndex) => {
          if (row.A23 === "N") {
            return "amountMul grayData";
          } else if (row.D23 !== 0 && row.D23 !== "0" && row.D23 !== "") {
            return "amountMul greenData";
          } else {
            return "amountMul";
          }
        },
        editable: (cell, row, rowIndex, colIndex) => {
          if (row.A23 === "Y") {
            return true;
          } else {
            return false;
          }
        },
      },
      {
        dataField: "D24",
        text: "24",
        editorClasses: "editing-all",
        validator: (newValue, row, column) => {
          if (isNaN(newValue)) {
            return {
              valid: false,
              message: "Amount should be numeric",
            };
          }
          return true;
        },
        classes: (cell, row, rowIndex, colIndex) => {
          if (row.A24 === "N") {
            return "amountMul grayData";
          } else if (row.D24 !== 0 && row.D24 !== "0" && row.D24 !== "") {
            return "amountMul greenData";
          } else {
            return "amountMul";
          }
        },
        editable: (cell, row, rowIndex, colIndex) => {
          if (row.A24 === "Y") {
            return true;
          } else {
            return false;
          }
        },
      },
      {
        dataField: "D25",
        text: "25",
        editorClasses: "editing-all",
        validator: (newValue, row, column) => {
          if (isNaN(newValue)) {
            return {
              valid: false,
              message: "Amount should be numeric",
            };
          }
          return true;
        },
        classes: (cell, row, rowIndex, colIndex) => {
          if (row.A25 === "N") {
            return "amountMul grayData";
          } else if (row.D25 !== 0 && row.D25 !== "0" && row.D25 !== "") {
            return "amountMul greenData";
          } else {
            return "amountMul";
          }
        },
        editable: (cell, row, rowIndex, colIndex) => {
          if (row.A25 === "Y") {
            return true;
          } else {
            return false;
          }
        },
      },
      {
        dataField: "D26",
        text: "26",
        editorClasses: "editing-all",
        validator: (newValue, row, column) => {
          if (isNaN(newValue)) {
            return {
              valid: false,
              message: "Amount should be numeric",
            };
          }
          return true;
        },
        classes: (cell, row, rowIndex, colIndex) => {
          if (row.A26 === "N") {
            return "amountMul grayData";
          } else if (row.D26 !== 0 && row.D26 !== "0" && row.D26 !== "") {
            return "amountMul greenData";
          } else {
            return "amountMul";
          }
        },
        editable: (cell, row, rowIndex, colIndex) => {
          if (row.A26 === "Y") {
            return true;
          } else {
            return false;
          }
        },
      },
      {
        dataField: "D27",
        text: "27",
        editorClasses: "editing-all",
        validator: (newValue, row, column) => {
          if (isNaN(newValue)) {
            return {
              valid: false,
              message: "Amount should be numeric",
            };
          }
          return true;
        },
        classes: (cell, row, rowIndex, colIndex) => {
          if (row.A27 === "N") {
            return "amountMul grayData";
          } else if (row.D27 !== 0 && row.D27 !== "0" && row.D27 !== "") {
            return "amountMul greenData";
          } else {
            return "amountMul";
          }
        },
        editable: (cell, row, rowIndex, colIndex) => {
          if (row.A27 === "Y") {
            return true;
          } else {
            return false;
          }
        },
      },
      {
        dataField: "D28",
        text: "28",
        editorClasses: "editing-all",
        validator: (newValue, row, column) => {
          if (isNaN(newValue)) {
            return {
              valid: false,
              message: "Amount should be numeric",
            };
          }
          return true;
        },
        classes: (cell, row, rowIndex, colIndex) => {
          if (row.A28 === "N") {
            return "amountMul grayData";
          } else if (row.D28 !== 0 && row.D28 !== "0" && row.D28 !== "") {
            return "amountMul greenData";
          } else {
            return "amountMul";
          }
        },
        editable: (cell, row, rowIndex, colIndex) => {
          if (row.A28 === "Y") {
            return true;
          } else {
            return false;
          }
        },
      },
      {
        dataField: "D29",
        text: "29",
        editorClasses: "editing-all",
        validator: (newValue, row, column) => {
          if (isNaN(newValue)) {
            return {
              valid: false,
              message: "Amount should be numeric",
            };
          }
          return true;
        },
        classes: (cell, row, rowIndex, colIndex) => {
          if (row.A29 === "N") {
            return "amountMul grayData";
          } else if (row.D29 !== 0 && row.D29 !== "0" && row.D29 !== "") {
            return "amountMul greenData";
          } else {
            return "amountMul";
          }
        },
        editable: (cell, row, rowIndex, colIndex) => {
          if (row.A29 === "Y") {
            return true;
          } else {
            return false;
          }
        },
      },
      {
        dataField: "D30",
        text: "30",
        editorClasses: "editing-all",
        validator: (newValue, row, column) => {
          if (isNaN(newValue)) {
            return {
              valid: false,
              message: "Amount should be numeric",
            };
          }
          return true;
        },
        classes: (cell, row, rowIndex, colIndex) => {
          if (row.A30 === "N") {
            return "amountMul grayData";
          } else if (row.D30 !== 0 && row.D30 !== "0" && row.D30 !== "") {
            return "amountMul greenData";
          } else {
            return "amountMul";
          }
        },
        editable: (cell, row, rowIndex, colIndex) => {
          if (row.A30 === "Y") {
            return true;
          } else {
            return false;
          }
        },
      },
      {
        dataField: "D31",
        text: "31",
        editorClasses: "editing-all",
        validator: (newValue, row, column) => {
          if (isNaN(newValue)) {
            return {
              valid: false,
              message: "Amount should be numeric",
            };
          }
          return true;
        },
        classes: (cell, row, rowIndex, colIndex) => {
          if (row.A31 === "N") {
            return "amountMul grayData";
          } else if (row.D31 !== 0 && row.D31 !== "0" && row.D31 !== "") {
            return "amountMul greenData";
          } else {
            return "amountMul";
          }
        },
        editable: (cell, row, rowIndex, colIndex) => {
          if (row.A31 === "Y") {
            return true;
          } else {
            return false;
          }
        },
      },
      {
        dataField: "Total",
        classes: (cell, row, rowIndex, colIndex) => {
          return "demo-row-odd-data" + row.TechnicianID;
        },
        text: "Total",
        editable: false,
      },
      {
        dataField: "Remarks",
        text: "Remarks",
        classes: "Remarkdata",
        editorClasses: "editing-all",
        editor: {
          type: Type.TEXT,
        },
      },
      {
        text: "Action",
        isDummyField: true,
        editable: false,
        classes: "actionClass",
        // classes: (cell, row, rowIndex, colIndex) => {
        //   return 'demo-row-odd'+row.JobTechnicianID;
        // },
        formatter: (cellContent, row) => {
          if (row.ShowSubmit === true) {
            return (
              <span className="saveBtnIn" title="Save">
                <AiOutlineCheckCircle />
              </span>
            );
          }
        },

        events: {
          onClick: (e, column, columnIndex, row, rowIndex) => {
            if (row.ShowSubmit === true) {
              this.handleactionFormater(row);
            }
          },
        },
      },
      {
        dataField: "DisplayData",
        text: "Name",
        classes: (cell, row, rowIndex, colIndex) => {
          return "mainsticy demo-row-odd" + row.TechnicianID;
        },
        editable: false,
      },
    ];

    var allowance = this.state.allowancedetails;
    return (
      <div>
        <HeaderBack />
        <div className=" container jobfilter mb-4 mt-4">
          <div className="headerfilter-all">
            <div className="viewcalander">
              <DatePicker
                selected={currnetMonth}
                onChange={(date) => this.handleInputChange(date)}
                dateFormat="MMM yyyy"
                showMonthYearPicker
                className="input-date-data-in outLine font_size"
              />
            </div>

            <div className="filterbtnsite">
              <Dropdown onSelect={this.handleDropdownSite}>
                <Dropdown.Toggle
                  variant="warning"
                  className="font_size"
                  id="dropdown-basic"
                >
                  {this.state.selectedSite}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  {listSiteId !== ""
                    ? listSiteId.map((item, indexdata) => {
                        return (
                          <Dropdown.Item
                            className="font_size"
                            key={indexdata}
                            eventKey={item.key}
                          >
                            {item.value}
                          </Dropdown.Item>
                        );
                      })
                    : ""}
                </Dropdown.Menu>
              </Dropdown>
            </div>
            <div className="filterbtn">
              <Dropdown onSelect={this.handleDropdown}>
                <Dropdown.Toggle
                  variant="info"
                  className="font_size btnhome"
                  id="dropdown-basic"
                >
                  {this.state.selectedStatus}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  {listStatus.map((item, index) => {
                    return (
                      <Dropdown.Item
                        className="font_size"
                        key={index}
                        eventKey={item.key}
                      >
                        {item.value}
                      </Dropdown.Item>
                    );
                  })}
                </Dropdown.Menu>
              </Dropdown>
            </div>
            <div className="filterbtn">
              <Button
                variant="primary"
                className="font_size"
                onClick={this.handleInputFetch}
              >
                Fetch
              </Button>
            </div>
            {this.state.submitbtn === true ? (
              <div className="submiteditbtn-all">
                <button
                  type="button"
                  onClick={this.handleSubmitAll}
                  className="btnval btn btn-success font_size"
                >
                  Submit
                </button>
              </div>
            ) : (
              ""
            )}
            {this.state.showbtn === true ? (
              <div className="submiteditbtnall">
                <img
                  src={addUserLogo}
                  alt="logo"
                  className="logo-add-user"
                  title="Add Technicians"
                  onClick={() => {
                    this.handleShow("Add User");
                  }}
                />
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
        <div className="table-container-all">
          <BootstrapTable
            classes="tabledata-all"
            keyField="TechnicianID"
            id="tabledata"
            data={allowance}
            columns={columns}
            overlay={overlayFactory({
              spinner: true,
            })}
            //  loading={this.state.loading}
            cellEdit={cellEditFactory({
              mode: "click",
              blurToSave: true,
              afterSaveCell: (oldValue, newValue, row, column) => {
                this.getInitialBid(oldValue, newValue, row, column);
              },
            })}
            noDataIndication={this.state.loadingData}
          />
        </div>
        <Offcanvas
          className="useroff"
          show={this.state.showData}
          scroll={this.state.scroll}
          name={this.state.name}
          backdrop={this.state.backdrop}
          placement={this.state.placement}
          onHide={this.handleClose}
        >
          <Offcanvas.Header className="popup_header" closeButton>
            <Offcanvas.Title className="header_title">
              <span className="title_contant">{this.state.customer}</span>
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <div className="container">
              <div className="rowUser justify-content-center">
                <div className="col-md-12">
                  <form
                    className="pr-5 mb-5 formUser"
                    method="POST"
                    onSubmit={this.handleSubmit}
                  >
                    <div className="rowUser">
                      <div className="col-md-12 form-group input-user">
                        <FloatingLabel
                          controlId="floatingSelect"
                          className="font_size"
                          label="Technicians *"
                        >
                          <Form.Select
                            aria-label="Floating label select example"
                            className="job_edit form__field_select"
                            name="TechnicianData"
                            onChange={this.handleDataChangeOther}
                          >
                            {this.state.listTechnicians !== ""
                              ? this.state.listTechnicians.map(
                                  (item, indexdata) => {
                                    return (
                                      <option
                                        key={indexdata}
                                        value={item.TechnicianID}
                                      >
                                        {item.TechnicianName +
                                          " - " +
                                          item.EmployeeID}
                                      </option>
                                    );
                                  }
                                )
                              : ""}
                          </Form.Select>
                        </FloatingLabel>
                      </div>
                    </div>
                    <div className="edit_input submitbtn mt-3">
                      <button
                        type="submit"
                        className="btnval btn btn-success font_size"
                      >
                        Submit
                      </button>
                      <button
                        type="button"
                        onClick={this.handleClose}
                        className="btnval btn btn-warning font_size"
                      >
                        Discard
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </Offcanvas.Body>
        </Offcanvas>
        {this.state.loading === true ? (
          <span className="preloader">
            <img src={loadingImg} className="loaderImg" />
          </span>
        ) : (
          ""
        )}
      </div>
    );
  }
}
